<!-- 材料管理 -->
<template>
<div class="container">
    <div class="index" v-if="!detail.show && !add.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>
        <div>
			<el-form :inline="true" :model="queryParams">
				<el-form-item label="">
                    <el-select v-model="queryParams.m_type" clearable placeholder="请选择材料分类" class="label">
                        <el-option v-for="(item,i) in mTypeList" :key="i+'m_type'" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="">
                    <el-input type="text" v-model="queryParams.mname" placeholder="请输入材料名称"></el-input>
                </el-form-item>
				<!-- <el-form-item label="">
                    <el-select v-model="queryParams.state" clearable placeholder="请选择审核状态" class="label">
                        <el-option v-for="(item,i) in stateList" :key="i+'sh'" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
					<el-button size="small" @click='toAdd()'>添加材料</el-button>
                </el-form-item>
			</el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="mname" show-overflow-tooltip label="材料名称" align="center">
                    </el-table-column>
                    <el-table-column prop="classify" label="材料分类" align="center">
						<template slot-scope="scope">
							<p>{{classifyObj[scope.row.classify]}}</p>
						</template>
                    </el-table-column>
                    <el-table-column prop="describe" show-overflow-tooltip label="材料描述" align="center">
                    </el-table-column>
                    <!-- <el-table-column prop="auditState" label="审核状态" align="center">
						<template slot-scope="scope">
							<p>{{stateObj[scope.row.auditState]}}</p>
						</template>
                    </el-table-column> -->
                    <el-table-column header-align="center" align="center" label="操作" fixed="right" width="200">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看详情</el-button>
							<template v-if="scope.row.auditState=='0'||scope.row.auditState=='3'">
							<el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
							<el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
							<!-- <el-button type="text" size="small" @click="handle(scope.row, '确定送审吗?')">送审</el-button> -->
							</template>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" :show="detail.show" @to-index="toIndex"></Detail>
	<Add :info.sync="add.info" v-show="add.show" @to-index="toIndex" @to-init="init"></Add>
</div>
</template>
<script>
import { handleMaterialsDetail, handleMaterialsList, materialsSubmitaudit, handleMaterialsDelete, getAuditrecordList } from '@/api/mechanismApi/curriculum.js'
import util from '@/utils/util.js'
export default {
    components:{
        Detail: ()=>import('./materialDetail.vue'),
		    Add: ()=>import('./addMaterial.vue'),
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				m_type:'',
				mname:'',
				state:'',
			},
			classifyObj:{
				'0':'线上',
				'1':'线下',
			},
			stateList:[
				{id:'0',label:'未送审'},
				{id:'1',label:'待审核'},
				{id:'2',label:'审核通过'},
				{id:'3',label:'审核不通过'},
			],
			stateObj: {
				'0':'未送审',
				'1':'待审核',
				'2':'审核通过',
				'3':'审核不通过',
			},
			mTypeList:[
				{id:'0',label:'线上'},
				{id:'1',label:'线下'},
			],
			tableData: [],
            detail:{
                info:{},
                show:false,
            },
			add:{
				info:{},
                show:false,
			},
		}
	},
	watch:{
		$route:{
			handler(n,o){
				let addType=n.query.type;
				if(n.path==="/supervise/material" && addType==='add'){
					this.toAdd();
				}
			},
			immediate:true,
		}
	},
	created() {
		this.getDataList();
	},
	methods: {
		init(){
			this.queryParams = {
				grade:'',
				date:'',
				state:'',
			};
			this.pageNum=1;
			this.getDataList();
		},
		getGrade(scope){
			if(!scope) return '';
			return util.getGrade(scope)
		},
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem("orgId"),
				pageNum:this.pageNum,
				pageSize:this.pageSize,
				classify:this.queryParams.m_type,
				mname:this.queryParams.mname,
				auditState:this.queryParams.state,
			}
			let res = await handleMaterialsList(params);
			if(res.result==='000000'){
				this.tableData=res.data?.list || [];
				this.totalPage=res.data?.total || 0;
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        async toDetail(item){
			let params = {
				mid: item.mid,
			};
			var { result, data } = await handleMaterialsDetail(params);
			let res= await getAuditrecordList(params);
			if (result == "000000") {
				this.detail.info = data;
				if(res.result==='000000'){
					this.detail.info.operateList=res.data || [];
				}
				this.detail.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
        },
        toIndex(){
            this.detail.show=false;
			this.add.show=false;
        },
		async edit(item){
			let params = {
				mid: item.mid,
			};
			var { result,data } = await handleMaterialsDetail(params);
			if (result == "000000") {
				this.add.info = data;
				this.add.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
		},
		// 送审
		async handle(item, text, type){
			let vm=this;
			util.handleCofirm(text, 'info',).then(async res => {
				let params = {
					mid: item.mid,
				};
				var { result } = await materialsSubmitaudit(params);
				if (result == "000000") {
					vm.$message({
						type: "success",
						message: "操作成功",
					});
					vm.getDataList();
				} else {
					vm.$message({
						type: "error",
						message: "操作失败",
					});
				}
			}).catch(err => {
				console.log('err', err) // cancel
			})
		},
		toAdd(){
			this.add.info.cid=null;
			this.add.show=true;
		},
		async del(item){
			let vm=this;
			util.handleCofirm('确定要删除材料吗?', 'info',).then(async res => {
				let params = {
					mid: item.mid,
				};
				var { result } = await handleMaterialsDelete(params);
				if (result == "000000") {
					vm.$message({
						type: "success",
						message: "操作成功",
					});
					vm.getDataList();
				} else {
					vm.$message({
						type: "error",
						message: "操作失败",
					});
				}
			}).catch(err => {
				console.log('err', err) // cancel
			})
		},
	},
	mounted() {
		
	},
}
</script>
<style lang="less">
    ::v-deep .el-tooltip__popper{max-width:50%}
</style>
<style lang="less" scoped>
.container{
	width: 100%;
	height: 100%;
	overflow: hidden;
}
.index {
	width: 100%;
	height: 100%;
    padding: 0px 30px 30px;
	overflow: auto;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}

}
</style>
